import Cookies from 'js-cookie';
import { call, put, takeEvery, all } from 'redux-saga/effects';

import { customerId } from 'common/helpers/tokenHelper';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import { listPayload as listClubMembershipPayload } from 'redux/clubMemberships/sagas';
import { listPayload as listProductPayload } from 'redux/products/sagas';

import { getPersonalizationBlock } from './api';
import {
  GET_PERSONALIZATION_CONTENT_REQUEST,
  GET_PERSONALIZATION_CONTENT_SUCCESS,
  PERSONALIZATION_CONTENT_OBJECT_REQUESTING,
  RESET_PERSONALIZATION_CONTENT_ISFETCHING
} from './constants';

function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: PERSONALIZATION_CONTENT_OBJECT_REQUESTING });
    const response = yield call(
      getPersonalizationBlock,
      action.code,
      cartId(),
      customerId()
    );
    yield put({
      type: GET_PERSONALIZATION_CONTENT_SUCCESS,
      payload: response.data
    });
    if (response.data.type === 'Product Collection') {
      yield call(listProductPayload, response.data.products);
    }
    if (response.data.type === 'Club Shipment') {
      yield call(listClubMembershipPayload, response.data.clubMemberships);
    }
  } catch (error) {
    yield put({ type: RESET_PERSONALIZATION_CONTENT_ISFETCHING });
    if (action.onError) {
      action.onError(error);
    } else {
      yield call(addAPIError, error);
    }
  }
}

function* watchList() {
  // Need take every so that gets multiple collections on a page
  yield takeEvery(GET_PERSONALIZATION_CONTENT_REQUEST, get);
}

export default function* personalizationBlockSagas() {
  yield all([watchList()]);
}

const cartId = () => Cookies.get('cartId');
